import api from "./Api";

class VendedorRevendaService {
  GetVendedorRevenda(payload) {
    return api.get("/v1/vendedorrevenda/" + payload).then((response) => {
      return response.data;
    });
  }

  PostVendedorRevenda(payload) {
    return api.post("/v1/vendedorrevenda/", payload).then((response) => {
      return response.data;
    });
  }

  PutVendedorRevenda(payload) {
    return api.put("/v1/vendedorrevenda/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteVendedorRevenda(payload) {
    return api.delete("/v1/vendedorrevenda/" + payload).then((response) => {
      return response.data;
    });
  }

  GetVendedorRevendaOData(payload) {
    return api.get("/OData/vendedorrevenda" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new VendedorRevendaService();
